"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.run = void 0;
const cache = __importStar(require("@actions/cache"));
const core = __importStar(require("@actions/core"));
const io = __importStar(require("@actions/io/"));
const path_1 = __importDefault(require("path"));
const restore_cache_1 = require("./restore-cache");
const enableCache = core.getInput('enable-cache') === 'true';
const cacheLocalStoragePath = `${core.getInput('cache-local-storage-path')}` || '';
function run() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            if (enableCache) {
                yield saveCache();
            }
        }
        catch (error) {
            const err = error;
            core.setFailed(err.message);
        }
        process.exit(0);
    });
}
exports.run = run;
function saveCache() {
    return __awaiter(this, void 0, void 0, function* () {
        const cacheKey = core.getState(restore_cache_1.STATE_CACHE_KEY);
        const matchedKey = core.getState(restore_cache_1.STATE_CACHE_MATCHED_KEY);
        if (!cacheKey) {
            core.warning('Error retrieving cache key from state.');
            return;
        }
        else if (matchedKey === cacheKey) {
            // no change in target directories
            core.info(`Cache hit occurred on key ${cacheKey}, not saving .venv.`);
            return;
        }
        core.info(`Saving .venv path: ${restore_cache_1.VENV_PATH}`);
        cacheLocalStoragePath
            ? yield saveCacheLocal(cacheKey)
            : yield cache.saveCache([restore_cache_1.VENV_PATH], cacheKey);
        core.info(`.venv saved with the key: ${cacheKey}`);
    });
}
function saveCacheLocal(cacheKey) {
    return __awaiter(this, void 0, void 0, function* () {
        const targetPath = `${cacheLocalStoragePath}${path_1.default.sep}${cacheKey}`;
        yield io.mkdirP(targetPath);
        yield io.cp(restore_cache_1.VENV_PATH, `${targetPath}${path_1.default.sep}.venv`, {
            recursive: true
        });
    });
}
run();
